import { useEffect, useState } from "react";
import { ticketsType } from "../../../../services/TicketsServices";

export default function useTicketTypes() {
  const [items, setItems] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 0,
    totalPages: 0,
  });
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const fetchList = (page = pagination.page, perPage = pagination.perPage, filter = activeFilter) => {
    const params = {
      page,
      per_page: perPage,
      ...(filter === "all" ? {} : { status: filter }),
    };

    return ticketsType("get", null, params)
      .then((res) => {
        const nextItems = res?.data || [];
        const nextTotal = res?.meta?.total ?? nextItems.length;
        setItems(nextItems);
        setPagination((prev) => ({
          ...prev,
          page,
          perPage,
          total: Number(nextTotal) || 0,
          totalPages: Math.ceil(((Number(nextTotal) || 0) * 1.0) / perPage),
        }));
      })
      .catch((err) => {
        // keep existing state on error
        // eslint-disable-next-line no-console
        console.error("Failed to fetch ticket types:", err);
      });
  };

  useEffect(() => {
    fetchList(1, pagination.perPage, activeFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changePage = (newPage) => fetchList(newPage, pagination.perPage, activeFilter);

  const changePerPage = (perPage) => {
    setPagination((prev) => ({ ...prev, perPage }));
    return fetchList(1, perPage, activeFilter);
  };

  const changeActiveFilter = (filter) => {
    setActiveFilter(filter);
    return fetchList(1, pagination.perPage, filter);
  };

  const requestDelete = (rowOrId) => {
    const id = typeof rowOrId === "number" ? rowOrId : rowOrId?.id;
    if (!id) return;
    setDeleteTarget({ id });
  };

  const cancelDelete = () => setDeleteTarget(null);

  const confirmDelete = async () => {
    if (!deleteTarget?.id) return;

    setDeleteLoading(true);
    try {
      await ticketsType("delete", null, null, deleteTarget.id);
      setDeleteTarget(null);
      await fetchList(pagination.page, pagination.perPage, activeFilter);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Failed to delete ticket type:", err);
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    items,
    activeFilter,
    pagination,
    deleteTarget,
    deleteLoading,
    fetchList,
    changePage,
    changePerPage,
    changeActiveFilter,
    requestDelete,
    cancelDelete,
    confirmDelete,
  };
}
